/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module LogsModule
 */

import { IApplicationLog } from 'generated-types';
import { Pipe, PipeTransform } from '@angular/core';

interface IPolicyRules extends Pick<IApplicationLog, 'persistent_session_id' | 'vh_match_rule' > {
    persistentSessionId?: IApplicationLog['persistent_session_id'];
    vhMatchRule?: IApplicationLog['vh_match_rule'];
    networkSecurityPolicyRule?: IApplicationLog['network_security_policy_rule_name'];
    httpSecurityPolicyRule?: IApplicationLog['http_security_policy_rule_name'];
    httpRequestPolicyRule?: IApplicationLog['http_request_policy_rule_name'];
    httpResponsePolicyRule?: IApplicationLog['http_response_policy_rule_name'];
}

/* eslint-disable @typescript-eslint/naming-convention */
/**
 * @description
 *     Pipe for extracting policy rules from an L7 traffic log.
 * @author Zhiqian Liu
 */
@Pipe({
    name: 'policyRules',
})
export class PolicyRulesPipe implements PipeTransform {
    /** @override */
    // eslint-disable-next-line class-methods-use-this
    public transform(log: IApplicationLog): IPolicyRules {
        if (!log) {
            return {};
        }

        const {
            persistent_session_id,
            vh_match_rule,
            network_security_policy_rule_name,
            http_security_policy_rule_name,
            http_request_policy_rule_name,
            http_response_policy_rule_name,
        } = log;

        return {
            persistent_session_id,
            vh_match_rule,
            networkSecurityPolicyRule: network_security_policy_rule_name,
            httpSecurityPolicyRule: http_security_policy_rule_name,
            httpRequestPolicyRule: http_request_policy_rule_name,
            httpResponsePolicyRule: http_response_policy_rule_name,
        };
    }
}
